export default {

  methods: {
    num_to_many: function (number) {

      return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(number);
    },
    currentdate() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      return yyyy + '-' + mm + '-' + dd;
    },
    date_rest(d1, n) {
      console.log(d1);
      d1 = d1.split("-");


      let today = new Date(new Date(parseInt(d1[0]), parseInt(d1[1]) - 1, parseInt(d1[2])).getTime() + (n * 24 * 60 * 60 * 1000));
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      return yyyy + '-' + mm + '-' + dd;
    },
    showNotification: function (text) {
      var allowDismiss = true

      $.notify({
        message: text.msj
      }, {
        type: text.bg,
        allow_dismiss: allowDismiss,
        newest_on_top: true,
        timer: 30000,
        placement: {
          from: 'bottom',
          align: 'right'
        },
        animate: {
          enter: 'animated bounceIn',
          exit: 'animated bounceOut'
        },
        template: '<div data-notify="container" class="bootstrap-notify-container alert alert-dismissible {0} ' + (allowDismiss ? "p-r-35" : "") + '" role="alert">' + '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button>' + '<span data-notify="icon"></span> ' + '<span data-notify="title">{1}</span> ' + '<span data-notify="message">{2}</span>' + '<div class="progress" data-notify="progressbar">' + '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' + '</div>' + '<a href="{3}" target="{4}" data-notify="url"></a>' + '</div>'
      })
    },
    to_excel_name2: function (t, id, wsname) {
      let uri = 'data:application/vnd.ms-excel;base64,';
      let template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' + wsname + '</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table border="1">' + t + '</table></body></html>',
        base64 = function (s) {
          return window.btoa(unescape(encodeURIComponent(s)))
        },
        format = function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          })
        }


      let table = document.getElementById(id);
      var ctx = {
        table: table.innerHTML,
      }
      let link = document.createElement('a');
      link.href = uri + base64(format(template, ctx));

      link.download = wsname + ".xls";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      ;

    },
   
  }
}



// WEBPACK FOOTER //
// ./src/mixin/mixin.js